import { useGraphEvent, useGraphInstance, Cell, Node, Edge } from "@antv/xflow"
import { createUnitTag, createUnitTagFromEdge } from "../nodes"
import { NodeShapes, SvgStreamDataState } from "../services/modal"
import { cellToNodeState, edgeToLineRecord } from "../services/storage"
import { EventMap, useEditorEventBusInstance } from "./useEventBusInstance"
import { EdgeView, Graph } from "@antv/x6"
import { isNotStream } from "./helper"

export const useCellEvents = () => {
  const eventBus = useEditorEventBusInstance()
  const graph = useGraphInstance()

  useGraphEvent('cell:added', ({ cell }: {cell: Cell}) => {
    if (graph?.isNode(cell)) {
      const node = cell as Node
      if (node.shape === NodeShapes.SvgNode) {
        const nodeData = cellToNodeState(node.toJSON())
        if (nodeData.showTag !== false) {
          const unitTagOptions = createUnitTag(nodeData)  
          const tagNode = graph?.addNode(unitTagOptions)
          tagNode.setZIndex(2)
        }
        cell.setZIndex(1)
      } else if (node.shape === NodeShapes.LineJump) {
        setTimeout(() => {
          eventBus.trigger(EventMap.lineJumpNodeAdded, {})
        }, 200);
      }
    } else if (graph?.isEdge(cell)) {
      const edge = cell as Edge
      const edgeRecord = edgeToLineRecord(edge.toJSON())
      if (isNotStream(edge)) return;
      if (edgeRecord.showTag !== false) {
        setTimeout(() => {
          const edgeView = <EdgeView>edge.findView(graph)
          const center = edgeView.getPointAtRatio(0.5)
          const unitTagOptions = createUnitTagFromEdge(edgeRecord, {x: center!.x, y: center!.y})  
          const tagNode = graph?.addNode(unitTagOptions)
          tagNode.setZIndex(1)
        }, 200);
        
      }
    }
  })

  useGraphEvent('cell:removed', ({ cell }: {cell: Cell}) => {
    if (graph?.isNode(cell)) {
      const node = cell as Node
      if (node.shape === NodeShapes.SvgStream) {
        const cellData = cell.getData() as SvgStreamDataState
        eventBus.trigger(EventMap.deleteSvgStream, cellData)
      } else if (node.shape === NodeShapes.LineJump) {
        const streams = graph.getConnectedEdges(node.id)
      }
    } else if (graph?.isEdge(cell)) {
      const source = cell.getSource();
      const target = cell.getTarget();
      const sourceNode = getEdgeEndNode(source, graph)
      const targetNode = getEdgeEndNode(target, graph);
      [sourceNode, targetNode].filter(item => !!item).forEach(item => {
        const svgStreamNode = item as Node;
        if (svgStreamNode.shape === NodeShapes.SvgStream) {
          graph.removeNode(svgStreamNode.id)
        }
      })
    }
  })
}

function getEdgeEndNode(end: any, graph: Graph) {
  if (!(end.cell && end.port)) {
    return
  }
  return graph.getCellById(end.cell)
}